import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";

const EditCustomerComponent = loadable(
  () => import("../../components/Customer/EditCustomer")
);
const EditCustomer = () => {
  const { id } = useParams()

  const { data, isLoading } = useGetHook({
    queryKey: [`customer-${id}`],
    url: `${APIS.CUSTOMER}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["customer"],
    navigateURL: "/customer",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}${id}/`;
    console.log(values)
    let formData = {
      ...values,
      "primary_contact": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    console.log(formData, "handle edit")
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Customer</span>
      </div>
      {isLoading ? <Spinner /> : <EditCustomerComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        data={data}
      />}
    </>
  );
};
export default EditCustomer;
